var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M473.655,423.721H38.345C17.167,423.721,0,406.554,0,385.376V126.618 c0-21.177,17.167-38.345,38.345-38.345h435.31c21.177,0,38.345,17.167,38.345,38.345v258.759 C512,406.554,494.833,423.721,473.655,423.721z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.62,
    y: 88.277,
    style: {
      fill: "#FF4B55"
    },
    width: 88.28,
    height: 335.45
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "150.068,126.526 132.413,141.238 97.102,141.238 79.447,126.526 79.447,111.813 97.102,97.1  132.413,97.1 150.068,111.813 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#73AF00"
    },
    points: "150.068,250.112 132.413,264.825 97.102,264.825 79.447,250.112 79.447,235.399  97.102,220.687 132.413,220.687 150.068,235.399  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#73AF00"
    },
    points: "150.068,188.319 132.413,203.031 97.102,203.031 79.447,188.319 79.447,173.606  97.102,158.894 132.413,158.894 150.068,173.606  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#73AF00"
    },
    points: "150.068,311.905 132.413,326.618 97.102,326.618 79.447,311.905 79.447,297.192  97.102,282.48 132.413,282.48 150.068,297.192  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB400"
    },
    points: "70.62,132.411 88.275,150.066 70.62,167.721  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB400"
    },
    points: "158.895,167.721 141.24,150.066 158.895,132.411  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB400"
    },
    points: "70.62,194.204 88.275,211.859 70.62,229.514  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB400"
    },
    points: "158.895,229.514 141.24,211.859 158.895,194.204  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB400"
    },
    points: "70.62,255.997 88.275,273.652 70.62,291.307  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB400"
    },
    points: "158.895,291.307 141.24,273.652 158.895,255.997  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB400"
    },
    points: "70.62,317.79 88.275,335.445 70.62,353.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB400"
    },
    points: "158.895,353.1 141.24,335.445 158.895,317.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB400"
    },
    points: "70.62,88.273 88.275,88.273 70.62,105.928  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB400"
    },
    points: "158.895,105.928 141.24,88.273 158.895,88.273  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.34,
    y: 158.897,
    style: {
      fill: "#FFB400"
    },
    width: 8.828,
    height: 44.14
  })), /*#__PURE__*/React.createElement("rect", {
    x: 97.1,
    y: 176.547,
    style: {
      fill: "#FF4B55"
    },
    width: 35.31,
    height: 8.828
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB400"
    },
    points: "141.24,166.249 132.413,158.894 132.413,203.031 141.24,195.675  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB400"
    },
    points: "88.275,195.675 97.102,203.03 97.102,158.894 88.275,166.249  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB400"
    },
    points: "114.758,97.1 97.102,97.1 79.447,111.813 79.447,119.169 114.758,119.169  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB400"
    },
    points: "114.758,141.238 132.412,141.238 150.068,126.526 150.068,119.169 114.758,119.169  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "114.758,132.411 97.102,119.221 114.758,105.928 132.413,119.221 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#73AF00"
    },
    points: "114.758,132.411 132.413,119.221 132.343,119.169 114.758,119.169  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#73AF00"
    },
    points: "114.758,119.169 114.758,105.928 97.171,119.169  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 97.1,
    y: 229.517,
    style: {
      fill: "#FF4B55"
    },
    width: 35.31,
    height: 26.483
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.41,
    y: 238.337,
    style: {
      fill: "#FFB400"
    },
    width: 8.828,
    height: 8.828
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.34,
    y: 238.337,
    style: {
      fill: "#F5F5F5"
    },
    width: 8.828,
    height: 8.828
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.34,
    y: 291.307,
    style: {
      fill: "#FF4B55"
    },
    width: 8.828,
    height: 8.828
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 123.59,
    y: 300.137,
    style: {
      fill: "#FFB400"
    },
    width: 8.828,
    height: 8.828
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.1,
    y: 300.137,
    style: {
      fill: "#FFB400"
    },
    width: 8.828,
    height: 8.828
  })), /*#__PURE__*/React.createElement("rect", {
    x: 110.34,
    y: 308.967,
    style: {
      fill: "#FF4B55"
    },
    width: 8.828,
    height: 8.828
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.28,
    y: 238.337,
    style: {
      fill: "#FFB400"
    },
    width: 8.828,
    height: 8.828
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "150.068,373.699 132.413,388.411 97.102,388.411 79.447,373.699 79.447,358.985  97.102,344.273 132.413,344.273 150.068,358.985 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB400"
    },
    points: "114.758,344.273 97.102,344.273 79.447,358.985 79.447,366.342 114.758,366.342  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFB400"
    },
    points: "114.758,388.411 132.412,388.411 150.068,373.699 150.068,366.342 114.758,366.342  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "132.413,370.756 114.758,379.583 97.102,370.756 97.102,361.928 114.758,353.1  132.413,361.928 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M280.009,136.34c-0.94-0.462-1.791,0.761-1.028,1.48c9.99,9.427,16.303,22.666,16.303,37.433 c0,29.007-23.316,52.279-51.986,52.279c-5.292,0-10.389-0.825-15.197-2.328c-0.996-0.311-1.641,1.025-0.783,1.621 c8.382,5.827,18.485,9.31,29.514,9.31c29.049,0,52.787-23.275,52.787-52.703C309.619,162.75,297.48,144.927,280.009,136.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M208.171,170.399l-2.159,6.109l5.08,4.021c0.658,0.521,0.275,1.579-0.564,1.557l-6.477-0.167 l-2.254,6.074c-0.292,0.787-1.417,0.749-1.655-0.055l-1.843-6.211l-6.474-0.267c-0.839-0.034-1.15-1.116-0.459-1.591l5.338-3.672 l-1.747-6.24c-0.226-0.808,0.706-1.439,1.372-0.928l5.142,3.942l5.395-3.59C207.563,168.917,208.451,169.609,208.171,170.399z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M234.407,183.649l-2.159,6.109l5.08,4.021c0.658,0.521,0.275,1.579-0.564,1.557l-6.477-0.167 l-2.254,6.074c-0.292,0.787-1.417,0.749-1.655-0.055l-1.843-6.211l-6.474-0.267c-0.839-0.034-1.15-1.116-0.459-1.591l5.338-3.672 l-1.747-6.24c-0.226-0.808,0.706-1.439,1.372-0.928l5.142,3.942l5.395-3.59C233.798,182.167,234.686,182.858,234.407,183.649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M234.142,156.355l-2.159,6.109l5.08,4.021c0.658,0.521,0.275,1.579-0.564,1.557l-6.477-0.167 l-2.254,6.074c-0.292,0.787-1.417,0.749-1.655-0.055l-1.843-6.211l-6.474-0.267c-0.839-0.034-1.15-1.116-0.459-1.591l5.338-3.672 l-1.747-6.24c-0.226-0.808,0.706-1.439,1.372-0.928l5.142,3.942l5.395-3.59C233.533,154.871,234.421,155.563,234.142,156.355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M235.034,130.01l-2.159,6.109l5.08,4.021c0.658,0.521,0.275,1.579-0.564,1.557l-6.477-0.167 l-2.254,6.074c-0.292,0.787-1.417,0.749-1.655-0.055l-1.843-6.211l-6.474-0.267c-0.839-0.034-1.15-1.116-0.459-1.591l5.338-3.672 l-1.747-6.24c-0.226-0.808,0.706-1.439,1.372-0.928l5.142,3.942l5.395-3.59C234.426,128.527,235.315,129.219,235.034,130.01z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M260.739,143.259l-2.159,6.109l5.08,4.021c0.658,0.521,0.275,1.579-0.564,1.557l-6.477-0.167 l-2.254,6.074c-0.292,0.787-1.417,0.749-1.655-0.055l-1.843-6.211l-6.474-0.267c-0.839-0.034-1.15-1.116-0.459-1.591l5.338-3.672 l-1.747-6.24c-0.226-0.808,0.706-1.439,1.372-0.928l5.142,3.942l5.395-3.59C260.131,141.777,261.02,142.469,260.739,143.259z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTm);
export default __webpack_public_path__ + "static/media/tm.427a926aafea9540d4f57357a1ade9c8.svg";
export { ForwardRef as ReactComponent };